const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const moment = require("moment");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const AT = require("../../core/vault/ActionTypes");
const OpsUser = require("../../core/vault/OpsUser");
const OpsCart = require("../vault/OpsCart");
const CopyTable = require("../data/CopyTable");
const LoadingCircle = require("../../core/view/LoadingCircle");
const {CircleUser, Square, SquareCheck} = require("lucide-react");

const styles = require("./styles/PageRedeemSubscription.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "RedeemSubscriptionReview",

		propTypes: {
			cart: PT.object.isRequired,
			user: PT.object.isRequired,
			onContinue: PT.func.isRequired,
			onGoBack: PT.func.isRequired,
			account: PT.object,
			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},
		vaultEvents: {
			showOfficeModal: function() {
				this.setState({useCodeStatus: ""});
			},
		},

		getInitialState: function() {
			const isLoggedIn = OpsUser.isLoggedIn(this.props.user);
			const isPlatformGuest = OpsUser.isPlatformGuest(this.props.user);
			return {
				useCodeStatus: "",
				termsAccepted: isLoggedIn && !isPlatformGuest,
				privacyAccepted: isLoggedIn && !isPlatformGuest,
			};
		},

		handleCheckboxChange: function(event) {
			this.setState({[event.target.name]: event.target.checked});
		},

		// Send request to use the code
		onSubmit: function() {
			const {user, cart} = this.props;
			const account = OpsCart.getFormSection(cart, "account");
			let parent;
			this.setState({useCodeStatus: "loading"});
			if (!user || !OpsUser.isLoggedIn(user)) {
				parent = {email: account.email, password: account.password};
			} else if (OpsUser.isPlatformGuest(user)) {
				parent = {email: account.email};
			}
			// REDEEM_SUBSCRIPTION_CODES_REQUEST is expecting an *array* of students and codes
			const studentData = _.get(cart, "redeemSubscriptionStudentData", {});
			const students = [
				{
					userID: studentData.userID,
					displayName: studentData.name,
				},
			];
			const codes = [_.get(cart, "redeemSubscriptionCode")] ?? [];
			this.props.dispatch({
				type: AT.REDEEM_SUBSCRIPTION_CODES_REQUEST,
				students,
				codes,
				parent,
			});
		},

		renderOrderSummaryCard: function() {
			const student = _.get(
				this.props.cart,
				"redeemSubscriptionStudentData",
				{}
			);
			const code = _.get(this.props.cart, "redeemSubscriptionCode", "");
			const isExtension = student.active && student.expiresAt;
			const currentExpiration = isExtension
				? moment(student.expiresAt)
				: moment();
			const newExpiration = currentExpiration.add(1, "Y").format("M/D/YY");
			return (
				<div className={styles.card}>
					<div className={styles.badgeContainer}>
						<div className={styles.badge}>
							<div className={styles.badgeText}>Code: </div>
							<div className={styles.badgeBoldText}>{code} Applied!</div>
						</div>
					</div>
					<div className={styles.cardContent}>
						<div className={styles.cardTextContainer}>
							<div className={styles.cardTitle}>
								Beast Academy Online Yearly Subscription
							</div>
							<div className={styles.cardStudentName}>
								<CircleUser />
								{student.name}
							</div>
						</div>
						<div className={styles.cardPriceContainer}>
							<span className={styles.oldPrice}>$99.99</span>
							<span className={styles.newPrice}>$0.00</span>
						</div>
					</div>
					<div className={styles.cardFooter}>
						Subscription active until {newExpiration}
					</div>
				</div>
			);
		},

		renderPricingLines: function() {
			return (
				<div>
					<div className={styles.pricingContainer}>
						<div className={styles.pricingLine}>
							<div>Subtotal</div>
							<div>$0.00</div>
						</div>
						<div className={styles.pricingLine}>
							<div>Tax</div>
							<div>$0.00</div>
						</div>
					</div>
					<hr className={styles.divider} />
					<div className={styles.pricingLineLarge}>
						<div>Total</div>
						<div>$0.00</div>
					</div>
				</div>
			);
		},

		renderAccountCheckboxes: function() {
			return (
				<form className={styles.termsAndConditionsForm}>
					Confirm to apply code:
					<div className={styles.checkboxContainer}>
						<div
							className={styles.customCheckbox}
							onClick={() =>
								this.handleCheckboxChange({
									target: {
										name: "termsAccepted",
										checked: !this.state.termsAccepted,
									},
								})
							}
						>
							{this.state.termsAccepted ? (
								<SquareCheck className={styles.checkboxIcon} />
							) : (
								<Square className={styles.checkboxIcon} />
							)}
						</div>
						<label>{CopyTable.getAcceptTermsCopy(styles)}</label>
					</div>
					<div className={styles.checkboxContainer}>
						<div
							className={styles.customCheckbox}
							onClick={() =>
								this.handleCheckboxChange({
									target: {
										name: "privacyAccepted",
										checked: !this.state.privacyAccepted,
									},
								})
							}
						>
							{this.state.privacyAccepted ? (
								<SquareCheck className={styles.checkboxIcon} />
							) : (
								<Square className={styles.checkboxIcon} />
							)}
						</div>
						<label>{CopyTable.getAcceptCoppaCopy()}</label>
					</div>
				</form>
			);
		},

		handleKeyDown: function(e) {
			if (
				e.key === "Enter" &&
				this.state.termsAccepted &&
				this.state.privacyAccepted
			) {
				e.preventDefault();
				this.onSubmit();
			}
		},

		render: function() {
			const orderSummaryCard = this.renderOrderSummaryCard();
			const pricingLines = this.renderPricingLines();
			const {user} = this.props;
			const isLoggedIn = OpsUser.isLoggedIn(user);
			const isPlatformGuest = OpsUser.isPlatformGuest(user);
			const accountCheckboxes =
				(!isLoggedIn || isPlatformGuest) && this.renderAccountCheckboxes();
			const reviewOrderText = isLoggedIn && (
				<div className={styles.bodyText}>Review your order details:</div>
			);

			return (
				<div
					className={styles.sectionWrapper}
					onKeyDown={this.handleKeyDown}
					tabIndex="0"
				>
					<h2 className={styles.title}>Order Summary</h2>
					{reviewOrderText}
					{orderSummaryCard}
					{pricingLines}
					{accountCheckboxes}
					<div className={styles.buttonsContainer}>
						<button
							className={styles.secondaryButton}
							onClick={this.props.onGoBack}
						>
							Go Back
						</button>
						<button
							className={styles.primaryButton}
							onClick={this.onSubmit}
							disabled={
								!this.state.termsAccepted || !this.state.privacyAccepted
							}
						>
							{this.state.useCodeStatus === "loading" ? (
								<div className={styles.loadingCircle}>
									<LoadingCircle colorType="white" noCenter={true} />
								</div>
							) : (
								"Apply Code"
							)}
						</button>
					</div>
				</div>
			);
		},
	})
);
